import { useOutletContext } from "react-router-dom";
import { useOperations } from "../../state/OperationsProvider";

const copy = {
  flow: { title: "Flow", detail: "How the Event moves from prep through service. Fixture sequence only — not a live scheduler." },
  commitments: { title: "Commitments", detail: "What we committed to deliver. Full commitment modeling comes later." },
  planning: { title: "Planning", detail: "Planning remains an operational view. Scheduling engines are not in this pass." },
  requirements: { title: "Requirements", detail: "What must be true. Critical unresolved requirements block Event Ready even if progress is high." },
  conditions: { title: "Conditions", detail: "Field and kitchen conditions that change how work should run." },
} as const;

export function EventSection({ surface }: { surface: keyof typeof copy }) {
  const { eventId } = useOutletContext<{ eventId: string }>();
  const { snapshot } = useOperations();
  const event = snapshot?.events.find((item) => item.id === eventId);
  if (!event) return null;
  const meta = copy[surface];

  return (
    <div className="event-section">
      <h3>{meta.title}</h3>
      <p className="muted">{meta.detail}</p>
      {surface === "flow" && <ul className="flow-list">{event.flow.map((step) => <li key={step.id}><strong>{step.label}</strong><small>{step.timeLabel}</small><p>{step.detail}</p></li>)}</ul>}
      {surface === "commitments" && <ul className="plain-list">{event.commitments.map((item) => <li key={item.id}><strong>{item.title}</strong><p>{item.detail}</p></li>)}</ul>}
      {surface === "planning" && <p>Planning notes will attach here. Current Key Times and Flow are the fixture stand-in for this Event.</p>}
      {surface === "requirements" && (
        <ul className="plain-list">
          {event.requirements.map((item) => (
            <li key={item.id}>
              <strong>{item.title} {item.critical ? "· Critical" : ""}</strong>
              <p>{item.detail}</p>
              <small>{item.resolved ? "Resolved" : "Unresolved"}</small>
            </li>
          ))}
        </ul>
      )}
      {surface === "conditions" && (
        <ul className="plain-list">
          {event.conditions.map((item) => (
            <li key={item.id}><strong>{item.title} · {item.severity}</strong><p>{item.detail}</p></li>
          ))}
        </ul>
      )}
    </div>
  );
}
